import fa from './fa/index'
import en from './en/index'

export default {
  fa,
  en
}
